/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Pairing_Existing_PropertyInputs */

const cs_ebr_pairing_existing_property = /** @type {(inputs: Ebr_Pairing_Existing_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`existující nemovitost`)
};

const en_ebr_pairing_existing_property = /** @type {(inputs: Ebr_Pairing_Existing_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`existing property`)
};

/**
* | output |
* | --- |
* | "existing property" |
*
* @param {Ebr_Pairing_Existing_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_pairing_existing_property = /** @type {((inputs?: Ebr_Pairing_Existing_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Pairing_Existing_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_pairing_existing_property(inputs)
	return cs_ebr_pairing_existing_property(inputs)
});